import { DATA_ORGA_LN_MODEL , getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'
import axios from "axios";

export default {
    namespaced: true,

    state: {

        buffORGADatPrepareDat : "",
        buffORGADatCtDat : "",
        dataORGASpecLN: Object.assign( {} ,DATA_ORGA_LN_MODEL) ,

        mstOrgaDat: [] ,
        mstDrugDat: [] ,
        mstMicDat  : [] ,
        mstResultDat: [],
        mstMethod:[],
        mstMethodResult:[],
        tmplateOrga:{}
    },

    getters: {

    },

    mutations: {
        setMstMethod (state, mstMethod) {
            state.mstMethod = mstMethod
        },


        setMstMethodResult (state, mstMethodResult) {
            state.mstMethodResult = mstMethodResult
        },




        setTmplateOrga (state, tmplateOrga) {
            state.tmplateOrga = tmplateOrga
        },


        setMstResultDat (state, mstResultDat) {
            state.mstResultDat = mstResultDat
        },

        setMstMicDat (state, mstMicDat) {
            state.mstMicDat = mstMicDat
        },

        setMstDrugDat (state, mstDrugDat) {
            state.mstDrugDat = mstDrugDat
        },

        setMstOrgaDat (state, mstOrgaDat) {
            state.mstOrgaDat = mstOrgaDat
        },


        setDataORGASpecLN (state, dataORGASpecLN) {
            state.dataORGASpecLN = dataORGASpecLN
        },

        setBuffORGADatPrepareDat (state, buffORGADatPrepareDat) {
            state.buffORGADatPrepareDat = buffORGADatPrepareDat
        },

        setBuffORGADatCtDat (state, buffORGADatCtDat) {
            state.buffORGADatCtDat = buffORGADatCtDat
        },

    },

    actions: {
        produceDoneFetching({commit},doneFetching){
            commit('setDoneFetching', doneFetching)
        },

        produceBuffORGADatPrepareDat({commit},buffORGADatPrepareDat){
            commit('setBuffORGADatPrepareDat', buffORGADatPrepareDat)
        },

        produceBuffORGADatCtDat({commit},buffDatCtDat){
            commit('setBuffORGADatCtDat', buffDatCtDat)
        },



        fetchMiscMasterDataForOrga({commit},datTo) {
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_misc_masterdata_for_orga`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setMstResultDat', res.data.result_mst)
                        commit('setMstMicDat', res.data.mic)
                        commit('setMstDrugDat', res.data.drug)
                        commit('setMstOrgaDat', res.data.orga)
                        commit('setTmplateOrga', res.data.tmplate)
                        commit('setMstMethod', res.data.method_mst)
                        commit('setMstMethodResult', res.data.method_result_mst)

                        resolve(res.data)
                    })
            }    )

        },


        fetchORGAOLDDat({commit},datTo){
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/laborga_by_spechnspecln`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log(res.data)
                        commit('setDataORGASpecLN', res.data)
                        // // const  tmp = res.data.dat_prepare.dat
                        // // console.log(tmp)
                        // // buffer.from("SGVsbG8gVmlzaGFsIFRoYWt1cg==", 'base64').toString('ascii')
                        if(res.data.dat_prepare.dat === null){
                            commit('setBuffORGADatPrepareDat',"")
                        }else{
                            commit('setBuffORGADatPrepareDat', Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8') )
                        }
                        // // **************************************************
                        if(res.data.dat_ct.dat === null){
                            commit('setBuffORGADatCtDat',"")
                        }else{
                            commit('setBuffORGADatCtDat', Buffer.from(res.data.dat_ct.dat, 'base64').toString('utf-8') )
                        }
                        // // console.log( Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8'))
                        resolve(res.data)
                    })
            })
        }
    }
}